// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Opcw","image":"styles_image__3jmlv","link":"styles_link__1Wy8s"};